import React, { useCallback, useState, useEffect } from 'react'
import { Alert, Button } from 'react-bootstrap'
import { usePickingPrepareDataState } from '../../../stores/PickingPrepareDataProvider'
import { useWithdrawalsState } from '../../../stores/WithdrawalsProvider'
import { ButtonWithLoadingState } from '../../Buttons'
import { useTranslation, Trans } from 'react-i18next'
import styled from 'styled-components'
import { useNavigate, useParams } from 'react-router-dom'
const StyledContainer = styled.div`
  @media screen and (min-width: 1081px) {
    position: sticky;
    top: 50px;
  }
`
const StyledCancelButton = styled(Button)`
  width: 100%;
  max-width: 250px;
`
const PickingPreparationSidebar = () => {
  const {
    submitPreparation,
    errorsOccurredOnSubmit,
    formDataHasChanged,
    resetFormData,
    setSuccessSubmit,
    successSubmit,
    loadedOrderData,
    partialPickingIsEnabled,
    partialPickingResult
  } = usePickingPrepareDataState()
  const {
    printPickinglist
  } = useWithdrawalsState()
  const { soId } = useParams()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [isSaving, setIsSaving,] = useState(false)
  const handleSubmit = useCallback(async e => {
    setSuccessSubmit(false)
    setIsLoading(true)
    setIsSaving(true)
    partialPickingIsEnabled && await submitPreparation()

    setIsSaving(false)
    setIsLoading(false)
  }, [partialPickingIsEnabled, setSuccessSubmit, submitPreparation])
  const handlePrintPickinglist = useCallback(async e => {
    await printPickinglist(soId)
    setTimeout(() => {
      navigate(`/localstorage/withdrawals/${soId}/pickcont`)
    }, 1500)
  }, [printPickinglist, soId, navigate])


  const handleClickCancel = () => {
    resetFormData();
  }
  useEffect(() => {
    let timeout = null
    if (!isLoading && !!successSubmit) {
      timeout = setTimeout(() => {
        setSuccessSubmit(false)
      }, 3000)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [isLoading, successSubmit, setSuccessSubmit])
  useEffect(() => {
    if (!!partialPickingResult?.succeeded) {
      handlePrintPickinglist()
    }
  }, [partialPickingResult, handlePrintPickinglist])


  const { t } = useTranslation()
  return (
    <StyledContainer>
      <header>
        <div className="h2">{t('pickingOverlayProgress:headerPreparation')}</div>
      </header>
      <div className="content">
        <ButtonWithLoadingState
          className="submit-btn mb-3"
          isLoading={isLoading}
          onClick={handleSubmit}
          disabled={isLoading || !loadedOrderData || !partialPickingIsEnabled}
          buttonText={t('pickingOverlayProgress:confirmPartialPicking')}
          loadingText={t('pickingOverlayProgress:confirmPartialPicking')}
        />
        {(formDataHasChanged) && (
          <>
            <StyledCancelButton className="mb-3" variant="secondary" onClick={handleClickCancel}>{t('cancelButton')}</StyledCancelButton>
            <div className=" alert alert-info" >{t('EmployeeFormHealthData:dataChange')}</div>
          </>
        )}
        <div className="mb-5" />
        {(!isLoading && !isSaving && !!errorsOccurredOnSubmit) && (
          <Alert variant="danger">
            <Trans i18nKey='pickingOverlayProgress:danger' />
          </Alert>
        )}
        {(!isLoading && !isSaving && !!successSubmit) && (
          <Alert variant="success">
            {t('pickingOverlayProgress:partialPickingSucceeded')}
          </Alert>
        )}
        {!!partialPickingResult?.shippingNo && (
          <Alert variant="info">
            {`${t('pickingOverlayProgress:partialPickingResult')} ${partialPickingResult.shippingNo}`}
          </Alert>
        )}
      </div>
    </StyledContainer>
  )
}

export default PickingPreparationSidebar
